module.exports = __webpack_public_path__ + "media/images/glyphs/euro-page-c40a1ab1063aa5700d4bc81f3181684a.svg";